export default __webpack_public_path__ + "static/media/galaxy-clean-img.b5dc0c2c.jpg";